import CustomPopup from "../../../../components/CustomPopup";
import React, {useContext} from "react";
import './HintConfirmDialog.css'
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";

type HintConfirmDialogProps = {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}


const HintConfirmDialog:React.FC<HintConfirmDialogProps> = ({isOpen, onConfirm, onCancel}) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);

    return (
        <CustomPopup isOpen={isOpen} onClose={onCancel}>
            <div className="hint-confirm-dialog-container">
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl} alt="pic"/>
                <img onClick={onCancel} className="exit-close-btn" src={imgUrls.closerBtnGreyUrl} alt="pic"/>
                <div className="hint-confirm-dialog-content-container">
                    <div className="my-roboto-regular">Are you sure you want to use a hint?</div>
                    <div className="my-roboto-regular margin-top-8">Daily leaderboards won't record</div>
                    <div className="my-roboto-regular">your score if you do.</div>
                </div>
                <div onClick={onConfirm} className="hint-dialog-confirm-btn my-roboto-medium">Confirm</div>
                <div onClick={onCancel} className="hint-dialog-cancel-btn my-roboto-regular">Cancel</div>
            </div>


        </CustomPopup>
    )
}

export  default HintConfirmDialog;